jQuery(document).ready(function($){
	console.log('Welcome to digerati!');

	$('.elementor-element .elementor-widget-digerati-image-carousel').each(function(){
		$(this).attr('data-widget_type', 'image-carousel.default');
		$(this).find('img').each(function(){
			$(this).removeClass('lazyloading');
		});
	});

	$('a[href^=http]').filter(function() {
		return this.hostname && this.hostname !== location.hostname;
	}).attr({
		target: '_blank'
	});

	$('.game-filters select').on('change', function(){
		var data = {};
		$(this).closest('.game-filters').find('select').each(function(){
			var paramName = $(this).attr('name');
			if($(this).val() != '') data[paramName] = $(this).val();
		});

		var searchParams = new URLSearchParams(data).toString();

		var url = location.protocol + '//' + location.host + location.pathname;
		if(searchParams != '') url += '?' + searchParams;

		window.location.replace(url);
	});
});